import React, { useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import {toastifyType} from './../constants/index';
const ToastHandler = () => {
  const dispatch = useDispatch();
  const { toastType, toastMessage } = useSelector(state => state.toast);
   
  useEffect(() => {
    if (toastType && toastMessage) {
      if (toastType === toastifyType.SHOW_SUCCESS_MESSAGE) {
        toast.success(toastMessage);
      } else if (toastType === toastifyType.SHOW_ERROR_MESSAGE) {
        toast.error(toastMessage);
      }

      // Clear toast
      dispatch({ type: toastifyType.SHOW_TOAST, payload: { type: null, message: '' } });
    }
  }, [toastType, toastMessage]);

  return <ToastContainer />;
};

export default ToastHandler;
